export default "__VITE_ASSET__8a3b7e66__"